import React from "react";
import { Col, Space } from "antd";

import EventUserList from "../../components/EventUserList";
import EventPrizeList from "../../components/EventPrizeList";

function CampingCarShow() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">2023 캠핑카쇼</h3>
                <EventUserList eventId={2} />
                <EventPrizeList eventId={2} />
            </Space>
        </div>
    );
}

export default CampingCarShow;
